import { render, staticRenderFns } from "./discrepancy-action-column.vue?vue&type=template&id=8b7c2c98&scoped=true"
import script from "./discrepancy-action-column.vue?vue&type=script&lang=js"
export * from "./discrepancy-action-column.vue?vue&type=script&lang=js"
import style0 from "./discrepancy-action-column.vue?vue&type=style&index=0&id=8b7c2c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7c2c98",
  null
  
)

export default component.exports